module.exports = __webpack_public_path__ + "static/media/leaderboard-img1.166e10b6.jpeg";